'use client';

import React from 'react';

export const useOnVisibilityChange = (ref: Element | null, callback?: (isVisible: boolean) => void) => {
  const isVisible = React.useRef(true);

  if (typeof window !== 'undefined') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const observer = React.useMemo(
      () =>
        new IntersectionObserver(([entry]: IntersectionObserverEntry[]) => {
          if (isVisible.current !== entry.isIntersecting) {
            isVisible.current = entry.isIntersecting;
            callback?.(entry.isIntersecting);
          }
        }),
      [callback],
    );

    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(() => {
      if (ref) {
        observer.observe(ref);
        // Remove the observer as soon as the component is unmounted
        return () => {
          observer.disconnect();
        };
      } else {
        return undefined;
      }
    }, [observer, ref]);
  }
};
